import React, {Component} from 'react';
import fetch from "fetch-retry";
import * as InitStatus from "../../constants/common/InitializationStatus";
import {jsonResponseHandler} from "../../utils/FetchHelper";
import {addPrefix} from "../../utils/UriUtil";
import If from "../common/control/If";
import RetryView from "../statistics/common/RetryView";

class DashboardTopEntry extends Component {

  constructor(props) {
    super(props);
    this.state = {
      list: [],
      initialized: InitStatus.INIT_READY
    }
  }

  // Mount후 인기글 호출
  componentDidMount() {
    this.getEntryTop();
  }

  // 인기글 API
  getEntryTop = () => {
    const {dispatch} = this.props;
    this.setState({initialized: InitStatus.INIT_DOING}, () => {

      fetch(addPrefix("/manage/statistics/dashboard/topEntry.json"), {
        credentials: 'include',
        headers: {'Content-Type': 'application/json'},
        retries: 2,
        retryDelay: 300,
        retryOn: [500]
      })
        .then(jsonResponseHandler(dispatch))
        .then(res => res.json())
        .then(res => {
          const data = res.data;
          this.setState({
            initialized: InitStatus.INIT_SUCCESS,
            list: (data && data.result) ? data.result : []
          });

        })
        .catch(e => {
          console.error(e);
          this.setState({initialized: InitStatus.INIT_FAIL});
        })
    });

  };


  // 리스트 렌더링
  renderItems(list) {
    return list.map((item, index) => (
      <tr className="row_type1" key={index}>
        <td className="fst">
          <div className="inner_cell"><em>{index + 1}</em></div>
        </td>
        <td>
          <div className="inner_cell">
            <a href={item.permalink} target="_blank" className="link_popular">{item.title}</a>
            <a href={addPrefix(`/manage/statistics/entry/${item.entryId}`)} target="_blank" className="btn_post">통계</a>
          </div>
        </td>
      </tr>
    ));
  }

  // 로딩 렌더링
  renderLoading() {
    return <tr className="row_type1 loading">
      <td colSpan="2">
        <div className="inner_cell"><span className="ico_blog ico_loading"></span></div>
      </td>
    </tr>;
  }


  render() {
    let {list, initialized} = this.state;
    const {isDoing, isEmpty, isFail, isSuccess} = InitStatus.init(initialized, list);

    return (
      <div className="box_blog_type1 box_popular">
        <strong className="tit_box">인기글</strong>
        <If condition={isFail}><RetryView retryCallback={this.getEntryTop}/></If>
        <If condition={!isFail}>
          <If condition={isEmpty}><p className="txt_none">인기 글이 없습니다.</p></If> {/*데이터없을때*/}
          <div className="wrap_tbl">
            <table className="tbl_tistory">
              <caption className="ir_caption">인기글</caption>
              <colgroup>
                <col style={{width: "20px"}}/>
                <col style={{width: "514px"}}/>
              </colgroup>
              <tbody>
              <If condition={!isDoing}>{this.renderItems(list)}</If>
              <If condition={isDoing}>{this.renderLoading()}</If>
              </tbody>
            </table>
          </div>
        </If>
      </div>
    );
  }
}

export default DashboardTopEntry;
